export const VIEW_TYPES = {
  PRESET_CHATBOT_SETTINGS: 'PRESET_CHATBOT_SETTINGS',
  COMMUNITY_CHATBOT_SETTINGS: 'COMMUNITY_CHATBOT_SETTINGS'
};
export const API_BASE_V1 =
  import.meta.env.VITE_SERVER_URL_V2 ||
  'https://apis-v2.residentboost.com/apis/v1';

export const API_ENDPOINTS = {
  SAVE_CONFIG_DETAILS: communityId =>
    `${API_BASE_V1}/communities/${communityId}/chatbot-config`
};
